import { Paper } from "@mui/material";
import useScreenDimensions from "../hooks/useScreenDimensions";

export default function PageLayout({ children, sideComponents = [] }) {
  const { isMobile, isTablet, windowHeight, windowWidth } =
    useScreenDimensions();
  const topComponents = false;
  const center = false;

  return (
    <>
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: 2,
          ml: { xs: 0, sm: 2 },
          marginTop: topComponents.length > 0 ? 0 : 2,
          maxWidth: center
            ? `${windowWidth}px`
            : {
                xs: `${windowWidth}px`,
                md:
                  sideComponents.length === 0
                    ? `${windowWidth}px`
                    : `${windowWidth - 170}px`,
                lg:
                  sideComponents.length === 0
                    ? `${windowWidth}px`
                    : `${windowWidth - 270}px`,
              },
          padding: isMobile ? 0 : 2,
          flex: 1,
          minHeight: `${windowHeight - 130}px`,
          // maxHeight: `${windowHeight - 130}px`,
        }}
        elevation={isMobile ? 0 : 3}
      >
        {children}
      </Paper>
      {sideComponents.length > 0 && (
        <Paper
          sx={{
            margin: 2,
            marginTop: topComponents.length > 0 ? 0 : 2,
            padding: 2,
            marginLeft: 0,
            display: isMobile ? "none" : "flex",
            width: isTablet ? "200px" : "350px",
            flexDirection: "column",
          }}
          elevation={3}
        >
          {sideComponents}
        </Paper>
      )}
    </>
  );
}
